"use client";

import { Icon } from "@afa-shared/afa-components";
import clsx from "clsx";
import React from "react";

import { AccessibilityIcon } from "./AccessibilityIcon";
import styles from "./AccessibilityMatrix.module.scss";

export interface AccessibilitySectionProps {
  imageMain: React.ReactNode;
  imagePermanent: React.ReactNode;
  imageTemporary: React.ReactNode;
  imageSituational: React.ReactNode;
  id?: string;
  labelPermanent: string;
  labelTemporary: string;
  labelSituational: string;
  accordionHeader: string | React.ReactNode;
  ariaLabel: string;
  children: React.ReactNode;
}

export const AccessibilitySection = ({
  imageMain,
  imagePermanent,
  imageTemporary,
  imageSituational,
  id,
  labelPermanent,
  labelTemporary,
  labelSituational,
  accordionHeader,
  ariaLabel,
  children,
}: AccessibilitySectionProps) => {
  const [isOpen, setIsOpen] = React.useState(false);
  return (
    <section className={styles["section"]} aria-label={ariaLabel}>
      <div className={styles["section__icon-container"]}>
        <AccessibilityIcon icon={imageMain} ariaDescribedBy={""} />
        <AccessibilityIcon
          icon={imagePermanent}
          label={labelPermanent}
          ariaDescribedBy={`permanent ${id}`}
        />
        <AccessibilityIcon
          icon={imageTemporary}
          label={labelTemporary}
          ariaDescribedBy={"tillfälligt"}
        />
        <AccessibilityIcon
          icon={imageSituational}
          label={labelSituational}
          ariaDescribedBy={"situationsbaserat"}
        />
      </div>
      <div className={styles["accordion"]}>
        <div className={styles["accordion-wrapper"]}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className={clsx(styles["accordion-button"], {
              [styles["accordion-button--open"]]: isOpen,
            })}
          >
            <div className={styles["accordion-button__image"]}>{imageMain}</div>

            <h2>{accordionHeader}</h2>
            <Icon name={isOpen ? "remove" : "add"} />
          </button>
          <div
            className={clsx(styles["accordion-content"], {
              [styles["accordion-content--open"]]: isOpen,
            })}
          >
            {children}
          </div>
        </div>
      </div>
    </section>
  );
};
